<template>
  <div>
    <!--Конфигурации приложения-->
    <div class="uk-card uk-card-default">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title uk-margin-remove-top">
              Конфигурации приложения
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <div v-if="no_access" class="uk-text-center tm-text-medium uk-margin">{{ local_page_keys.alert_page_for_admin }}</div>
        <div v-else class="uk-grid uk-grid-divider uk-child-width-1-3" data-uk-grid>
          <!--версии-->
          <div>
            <div class="uk-grid uk-grid-small uk-child-width-1-1 uk-flex-middle" data-uk-grid>
              <div>
                <div class="uk-margin-small">{{ local_page_keys.lable_current_version_application }}:</div>
                <div class="uk-grid uk-grid-small uk-flex-middle uk-child-width-1-1" data-uk-grid>
                  <div>
                    <input type="text" class="uk-input" v-model="actual_version"/>
                  </div>
                  <div>
                    <div>
                      <input v-model="boolean_android" type="checkbox" class="uk-checkbox"/> <span class="uk-text-small">{{local_page_keys.is_critical_android_version}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="uk-margin-small">{{ local_page_keys.lable_current_version_application_ios }}:</div>
                <div class="uk-grid uk-grid-small uk-flex-middle uk-child-width-1-1" data-uk-grid>
                  <div class="uk-width-expand">
                    <input type="text" class="uk-input" v-model="actual_version_ios"/>
                  </div>
                  <div>
                    <div>
                      <input v-model="boolean_ios" type="checkbox" class="uk-checkbox"/> <span class="uk-text-small">{{local_page_keys.is_critical_ios_version}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button v-if="(actual_version !== '' && actual_version !== data_actual_version && actual_version != 0) ||
                 (actual_version_ios !== '' && actual_version_ios !== data_actual_version_ios && actual_version_ios != 0) ||
                 (boolean_android !== data_boolean_android) ||
                 (boolean_ios !== data_boolean_ios)"
                        type="button"
                        class="uk-button uk-button-success"
                        @click="submitVersion">
                  {{ local_page_keys.button_save }}
                </button>
                <button v-else type="button" class="uk-button uk-button-success" disabled>
                  {{ local_page_keys.button_save }}
                </button>
              </div>
            </div>
          </div>
          <!--Время задержки отправки пуша обновления-->
          <div>
            <div class="uk-grid uk-grid-small uk-child-width-1-1 uk-flex-middle" data-uk-grid>
              <div>
                <div class="uk-margin-small">{{ local_page_keys.lable_update_delay_time }}:</div>
                <input class="uk-input" v-model="actual_delay_time" type="number" min="1" max="60" step="1"/>
              </div>
              <div>
                <button
                    v-if="actual_delay_time !== '' && actual_delay_time !== data_delay_time && actual_delay_time != 0 && actual_delay_time <= 23"
                    type="button"
                    class="uk-button uk-button-success"
                    @click="submitDelayTime">
                  {{ local_page_keys.button_save }}
                </button>
                <button v-else type="button" class="uk-button uk-button-success" disabled>
                  {{ local_page_keys.button_save }}
                </button>
              </div>
            </div>
          </div>
          <!--Отправка уведомлений об обновлениях-->
          <div>
            <div class="uk-grid uk-grid-small uk-child-width-1-1 uk-flex-middle" data-uk-grid>
              <div>
                <div class="uk-margin-small">
                  {{ local_page_keys.lable_send_update_notif }}:
                </div>
              </div>
              <div>
                <md-radio v-model="actual_send_update_notif" value="true">{{ local_page_keys.lable_send_update_notif_on }}</md-radio>
                <md-radio v-model="actual_send_update_notif" value="false">{{ local_page_keys.lable_send_update_notif_off }}</md-radio>
              </div>
              <div>
                <button
                    v-if="actual_send_update_notif !== data_send_update_notif"
                    type="button" class="uk-button uk-button-success"
                    @click="submitSendUpdateNotif">
                  {{ local_page_keys.button_save }}
                </button>
                <button v-else type="button" class="uk-button uk-button-success" disabled>
                  {{ local_page_keys.button_save }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Настройки времени простоя заказов-->
    <div class="uk-card uk-card-default uk-margin">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title uk-margin-remove-top">
              {{ local_page_keys.title_card_head }}
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <md-field :mdClearable="true">
          <label for="retouchersSelect">{{ local_page_keys.label_retouchers_select }}:</label>
          <md-select v-model="selectedRetouchers" ref="retouchersSelect" name="retouchersSelect" id="retouchersSelect" multiple>
            <md-option v-for="retoucher of retouchersList" :key="retoucher.index" :value="retoucher.id">
              {{ retoucher.name !== '' ? retoucher.name : retoucher.email }} ({{ retoucher.email }}, {{ retoucher.role }})
            </md-option>
          </md-select>
        </md-field>
        <md-field :mdClearable="true">
          <label for="pro_retouchersSelect">{{ local_page_keys.label_pro_retouchers_select }}:</label>
          <md-select v-model="selectedProRetouchers" ref="pro_retouchersSelect" name="pro_retouchersSelect"
                     id="pro_retouchersSelect" multiple>
            <md-option v-for="pro_retoucher of pro_retouchersList" :key="pro_retoucher.index" :value="pro_retoucher.id">
              {{ pro_retoucher.name !== '' ? pro_retoucher.name : pro_retoucher.email }} ({{ pro_retoucher.email }},
              {{ pro_retoucher.role }})
            </md-option>
          </md-select>
        </md-field>
        <md-field :mdClearable="true">
          <label for="retoucherLimitTime">{{ local_page_keys.label_retoucher_limit_input }}:</label>
          <md-input type="time" v-model="retoucherLimitTime" ref="retoucherLimitTime" name="retoucherLimitTime"
                    id="retoucherLimitTime"></md-input>
        </md-field>
        <md-field :mdClearable="true">
          <label for="retoucherRejectedLimitTime">Лимит времени ожидания заказа в статусе 'rejected-admin-to-retoucher' для бездействующего
            ретушера:</label>
          <md-input type="time" v-model="retoucherRejectedLimitTime" ref="retoucherRejectedLimitTime"
                    name="retoucherRejectedLimitTime" id="retoucherRejectedLimitTime"></md-input>
        </md-field>
        <md-field :mdClearable="true">
          <label for="retoucherRejectedBusyLimitTime">Максимальный лимит времени ожидания заказа 'rejected-admin-to-retoucher' для
            ретушера:</label>
          <md-input type="time" v-model="retoucherRejectedBusyLimitTime" ref="retoucherRejectedBusyLimitTime"
                    name="retoucherRejectedBusyLimitTime" id="retoucherRejectedBusyLimitTime"></md-input>
        </md-field>
        <md-field :mdClearable="true">
          <label for="pro_retoucherLimitTime">{{ local_page_keys.label_pro_retoucher_limit_input }}:</label>
          <md-input type="time" v-model="pro_retoucherLimitTime" ref="pro_retoucherLimitTime"
                    name="pro_retoucherLimitTime" id="pro_retoucherLimitTime"></md-input>
        </md-field>
        <md-field :mdClearable="true">
          <label for="retoucher_extra_minutes_for_queue_priority">{{ local_page_keys.label_retoucher_extra_minutes_for_queue_priority }}:</label>
          <md-input type="number" min="1" max="600" step="1" v-model="retoucher_extra_minutes_for_queue_priority" ref="retoucher_extra_minutes_for_queue_priority"
                    name="retoucher_extra_minutes_for_queue_priority" id="retoucher_extra_minutes_for_queue_priority"></md-input>
        </md-field>
        <md-field :mdClearable="true">
          <label for="pro_retoucher_extra_minutes_for_queue_priority">{{ local_page_keys.label_pro_retoucher_extra_minutes_for_queue_priority }}:</label>
          <md-input type="number" min="1" max="600" step="1" v-model="pro_retoucher_extra_minutes_for_queue_priority" ref="pro_retoucher_extra_minutes_for_queue_priority"
                    name="pro_retoucher_extra_minutes_for_queue_priority" id="pro_retoucher_extra_minutes_for_queue_priority"></md-input>
        </md-field>
        <div class="uk-margin">
          <button v-if="changesWasInserted" type="button" class="uk-button uk-button-success" @click="submitDelayOptions">
            {{ local_page_keys.label_button_save_changes }}
          </button>
          <button v-else type="button" class="uk-button uk-button-success" disabled="disabled">
            {{ local_page_keys.label_disabled_button }}
          </button>
        </div>
      </div>
    </div>
    <!-- Adding ips to lower recaptcha-->
    <div class="uk-card uk-card-default uk-margin">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title uk-margin-remove-top">
              Adding ips to lower recaptcha
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <div class="uk-grid uk-grid-small uk-child-width-1-1 uk-flex-middle" data-uk-grid>
          <v-container>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    <input  class="uk-input" type="text"  ref="ipAddressInput" :rules="ipAddressRules" v-model="recaptchaIp">
                  </v-card-title>
                  <v-card-actions>
                    <v-btn color="green" @click="addIp">Add Item</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="4" v-for="(ip, index) in lowRecaptchaIps" :key="index">
                <v-card>
                  <v-card-title>
                    <v-text-field v-model="ip.ip" label="Edit name" />
                  </v-card-title>
                  <v-card-actions>
                    <v-btn color="red" @click="deleteIp(index)">Delete</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </div>
    <!-- Order page selection-->
<!--    <div class="uk-card uk-card-default uk-margin">-->
<!--      <div class="uk-card-header">-->
<!--        <div class="uk-grid uk-flex-middle" data-uk-grid>-->
<!--          <div class="uk-width-expand">-->
<!--            <div class="uk-card-title uk-margin-remove-top">-->
<!--              Order page selection - Standard or FuncBased-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="uk-card-body">-->
<!--        <div class="uk-grid uk-grid-small uk-child-width-1-1 uk-flex-middle" data-uk-grid>-->
<!--          <div>-->
<!--            <md-radio v-model="defaultOrderPageValue" value="standard">Standard</md-radio>-->
<!--            <md-radio v-model="defaultOrderPageValue" value="funcBased">FuncBased</md-radio>-->
<!--          </div>-->
<!--          <div>-->
<!--            <button type="button" class="uk-button uk-button-success" @click="updateOrderPageValue(defaultOrderPageValue)">-->
<!--              {{ local_page_keys.button_save }}-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- Order cache log on/off selection-->
    <div class="uk-card uk-card-default uk-margin">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title uk-margin-remove-top">
              Order cache log on/off selection
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <div class="uk-grid uk-grid-small uk-child-width-1-1 uk-flex-middle" data-uk-grid>
          <div>
            <md-radio v-model="defaultOrderCacheLogValue" value="1">On</md-radio>
            <md-radio v-model="defaultOrderCacheLogValue" value="0">Off</md-radio>
          </div>
          <div>
            <button type="button" class="uk-button uk-button-success" @click="updateOrderCacheLogValue(defaultOrderCacheLogValue)">
              {{ local_page_keys.button_save }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminConfigs",
  data: () => ({
    role: '',
    defaultOrderPageValue: 'standard',
    defaultOrderCacheLogValue: '0',
    defaultOrderPage:1,
    local_page_keys: {},
    no_access: true,
    new_actual_version: '',
    actual_version: 0.00,
    actual_version_ios: 0.00,
    boolean_android: true,
    data_boolean_android: true,
    boolean_ios: true,
    data_boolean_ios: true,
    data_actual_version: 0,
    data_actual_version_ios: 0,
    actual_delay_time: 1,
    data_delay_time: 1,
    data_send_update_notif: true,
    actual_send_update_notif: true,
    retouchersList: [],
    pro_retouchersList: [],
    selectedRetouchers: [],
    selectedProRetouchers: [],
    beforeUpdateRetouchers: '',
    beforeUpdateProRetouchers: '',
    beforeUpdateRetoucherDelay: '',
    beforeUpdateProRetoucherDelay: '',
    beforeUpdateRetoucherRejectedDelay: '',
    beforeUpdateRetoucherRejectedBusyDelay: '',
    retoucherLimitTime: null,
    pro_retoucherLimitTime: null,
    retoucherRejectedLimitTime: null,
    retoucherRejectedBusyLimitTime: null,
    beforeUpdate_retoucher_extra_minutes_for_queue_priority:'',
    beforeUpdate_pro_retoucher_extra_minutes_for_queue_priority:'',
    retoucher_extra_minutes_for_queue_priority:'',
    pro_retoucher_extra_minutes_for_queue_priority:'',
    lowRecaptchaIps: [],
    recaptchaIp: '',
    validRecaptchaIp: false,
    ipAddressErrors: [],
    ipAddressRules: [
      v => !!v || 'IP Address is required',
      v => /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$|^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/.test(v) || 'IP Address must be valid',
    ],
  }),
  methods: {
    async addIp() {
      let validation = this.validateIPAddress();
      if (validation === true) {
        this.lowRecaptchaIps.push({ip: this.recaptchaIp});
        this.recaptchaIp = '';
        await this.updateLowlowRecaptchaIps();
      } else {
        this.recaptchaIp = '';
        //console.log(validation);
      }
    },
    async deleteIp(index) {
      this.lowRecaptchaIps.splice(index, 1);
      await this.updateLowlowRecaptchaIps();
    },
    validateIPAddress() {
      this.ipAddressErrors = [];
      const validationResult = this.ipAddressRules.map(rule => rule(this.recaptchaIp)).filter(result => result !== true);
      const checkIfArrayContainsOnlyUniqueObjects = this.checkIfArrayContainsOnlyUniqueObjects(this.lowRecaptchaIps);
      if (validationResult.length > 0) {
        // There are validation errors
       this.ipAddressErrors = validationResult;
        //return this.ipAddressErrors = validationResult;
        alert(JSON.stringify(this.ipAddressErrors))
      } else if(!checkIfArrayContainsOnlyUniqueObjects) {
        alert('This ip - ' + this.recaptchaIp + ' already exists!');
      } else {
        return true;
        // The input is valid
        //alert('IP Address is valid');
      }
    },
    checkIfArrayContainsOnlyUniqueObjects(array) {
      const seen = new Set();
      for (const obj of array) {
        const objString = JSON.stringify(obj);

        if (seen.has(objString)) {
          return false;
        }
        seen.add(objString);
      }
      return true;
    },
    async getRole() {
      await this.$store.dispatch("profile/role");
      this.role = await this.$store.getters["profile/role"];
      this.no_access = this.role !== 'admin';
      await this.getActualAppConfig();
    },
    async submitVersion() {
      if (confirm(this.local_page_keys.confirm_actual_app_version)) {
        try {
          let actual_app_version = this.actual_version;
          let actual_app_version_ios = this.actual_version_ios;
          let is_critical_update_android = this.boolean_android;
          let is_critical_update_ios = this.boolean_ios;
          await this.$store.dispatch('adminAppConfig/updateAppVersion', {actual_app_version, actual_app_version_ios, is_critical_update_android, is_critical_update_ios})
          let data = await this.$store.getters['adminAppConfig/updateAppVersion'];
          this.actual_version = data.actual_app_version.value;
          this.actual_version_ios = data.ios_app_version.value;
          this.boolean_android = data.is_critical_update_android.value === "1";
          this.data_boolean_android = data.is_critical_update_android.value === "1";
          this.boolean_ios = data.is_critical_update_ios.value === "1";
          this.data_boolean_ios = data.is_critical_update_ios.value === "1";
          this.data_actual_version = data.actual_app_version.value;
          this.data_actual_version_ios = data.ios_app_version.value;
          this.actual_delay_time = data.delay_time.value;
          this.data_delay_time = data.delay_time.value;
        } catch (e) {
          // alert(this.local_page_keys.alert_error_update)
        }

      }
    },
    async submitDelayTime() {
      if (this.data_actual_version === '') {
        this.actual_delay_time = this.data_delay_time;
        alert(this.local_page_keys.alert_error_validate_delay_time);
      } else {
        if (confirm(this.local_page_keys.confirm_delay_time)) {
          let delay_time = this.actual_delay_time;
          try {
            await this.$store.dispatch('adminAppConfig/updateDelayTime', {delay_time});
            let data = await this.$store.getters['adminAppConfig/updateDelayTime'];
            this.actual_version = data.actual_app_version.value;
            this.actual_version_ios = data.ios_app_version.value;
            this.boolean_android = data.is_critical_update_android.value=== "1";
            this.data_boolean_android = data.is_critical_update_android.value === "1";
            this.boolean_ios = data.is_critical_update_ios.value === "1";
            this.data_boolean_ios = data.is_critical_update_ios.value === "1";
            this.data_actual_version = data.actual_app_version.value;
            this.actual_delay_time = data.delay_time.value;
            this.data_delay_time = data.delay_time.value;
            this.actual_send_update_notif = String (data.send_update_notif.value);
            this.data_send_update_notif = String (data.send_update_notif.value);

          } catch (e) {
            // alert(this.local_page_keys.alert_error_update);
          }
        }
      }
    },
    async updateOrderPageValue(value){
      if (confirm('Are you sure that you want to change default order page')) {

        try {
          await this.$store.dispatch('adminAppConfig/updateOrderPageDefaultForAll', {order_page_type: value});
          let data = await this.$store.getters['adminAppConfig/updateOrderPageDefaultForAll'];
          alert(data.success);
        } catch (e) {
          alert(this.local_page_keys.alert_error_update);
        }
      }
    },
    async updateLowlowRecaptchaIps(){
      try {
        await this.$store.dispatch('adminAppConfig/updateLowRecaptchaIpsValue', {low_recaptcha_ips_value: this.lowRecaptchaIps});
        let data = await this.$store.getters['adminAppConfig/updateLowRecaptchaIpsValue'];
        alert(data.success);
      } catch (e) {
        alert(this.local_page_keys.alert_error_update);
      }

    },
    async updateOrderCacheLogValue(value){
      if (confirm('Are you sure that you want to change default order page')) {

        try {
          await this.$store.dispatch('adminAppConfig/updateOrderCacheLogValue', {cache_log_value: value});
          let data = await this.$store.getters['adminAppConfig/updateOrderCacheLogValue'];
          alert(data.success);
        } catch (e) {
          alert(this.local_page_keys.alert_error_update);
        }
      }
    },
    async submitSendUpdateNotif() {

      if (confirm(this.local_page_keys.confirm_delay_time)) {
        let send_update_notif = this.actual_send_update_notif;
        try {
          await this.$store.dispatch('adminAppConfig/updateSendUpdateNotif', {send_update_notif});
          let data = await this.$store.getters['adminAppConfig/updateSendUpdateNotif'];
          this.actual_version = data.actual_app_version.value;
          this.actual_version_ios = data.ios_app_version.value;
          this.boolean_android = data.is_critical_update_android.value=== "1";
          this.data_boolean_android = data.is_critical_update_android.value === "1";
          this.boolean_ios = data.is_critical_update_ios.value === "1";
          this.data_boolean_ios = data.is_critical_update_ios.value === "1";
          this.actual_delay_time = data.delay_time.value;
          this.data_delay_time = data.delay_time.value;
          this.actual_send_update_notif = String (data.send_update_notif.value);
          this.data_send_update_notif =String (data.send_update_notif.value);
        } catch (e) {
          // alert(this.local_page_keys.alert_error_update);
        }
      }
    },
    async getActualAppConfig() {
      try {
        await this.$store.dispatch('adminAppConfig/actualAppConfig');
        let data = await this.$store.getters['adminAppConfig/actualAppConfig'];
        this.actual_version = data.actual_app_version.value;
        this.actual_version_ios = data.ios_app_version.value;
        this.boolean_android = data.is_critical_update_android.value=== "1";
        this.data_boolean_android = data.is_critical_update_android.value === "1";
        this.boolean_ios = data.is_critical_update_ios.value === "1";
        this.data_boolean_ios = data.is_critical_update_ios.value === "1";
        this.data_actual_version = data.actual_app_version.value;
        this.data_actual_version_ios = data.ios_app_version.value;
        this.actual_delay_time = data.delay_time.value;
        this.data_delay_time = data.delay_time.value;
        this.actual_send_update_notif = String (data.send_update_notif.value);
        this.data_send_update_notif = String (data.send_update_notif.value);
        switch(String (data.order_page.value)){
          case '2':
            this.defaultOrderPageValue = 'funcBased';
            break;
          default:
            this.defaultOrderPageValue = 'standard';
            break;
        }
        this.defaultOrderCacheLogValue = data.order_cache_logs.value;
        this.lowRecaptchaIps = 'low_recaptcha_ips' in data && data.low_recaptcha_ips.value ? JSON.parse(data.low_recaptcha_ips.value) : [];
        //console.log(data.max_pro_retoucher_delay.value);
        this.filterForDelaySettings(data);

      } catch (e) {
        // alert(this.local_page_keys.alert_error_index_data);
      }
    },
    async getRetouchersList() {
      await this.$store.dispatch('users/retouchersList', 'retoucher')
      let data = await this.$store.getters['users/retouchersList'];
      this.retouchersList = Object.values(data)
    },
    async getProRetouchersList() {
      await this.$store.dispatch('users/retouchersList', 'pro-retoucher')
      let data = await this.$store.getters['users/retouchersList'];
      this.pro_retouchersList = Object.values(data)
    },
    async submitDelayOptions() {
      let payload = {};
      if (this.selectedRetouchers.length > 0 && JSON.stringify(this.selectedRetouchers) !== '[""]') {
        payload['ignore_retouchers'] = JSON.stringify(this.selectedRetouchers);
      } else if (JSON.stringify(this.selectedRetouchers) === '[""]' && this.selectedRetouchersChanged) {
        if (confirm(this.local_page_keys.confirm_retouchers_list_ignore)) {
          payload['ignore_retouchers'] = ''
        }
      }
      if (this.selectedProRetouchers.length > 0 && JSON.stringify(this.selectedProRetouchers) !== '[""]') {
        payload['ignore_pro_retouchers'] = JSON.stringify(this.selectedProRetouchers);
      } else if (JSON.stringify(this.selectedProRetouchers) === '[""]' && this.selectedProRetouchersChanged && confirm(this.local_page_keys.confirm_pro_retouchers_list_ignore)) {
        payload['ignore_pro_retouchers'] = '';
      }
      if (this.retoucherLimitTime !== null && this.retoucherLimitTime !== '00:00' && this.retoucherLimitTime !== '') {
        payload['max_retoucher_delay'] = this.retoucherLimitTime
      } else if (this.retoucherLimitTime === '') {
        if (confirm(this.local_page_keys.confirm_retouchers_delay_time)) {
          payload['max_retoucher_delay'] = '';
        }
      }
      if (this.retoucherRejectedLimitTime !== null && this.retoucherRejectedLimitTime !== '00:00' && this.retoucherRejectedLimitTime !== '') {
        payload['max_retoucher_rejected_delay'] = this.retoucherRejectedLimitTime
      } else if (this.retoucherRejectedLimitTime === '') {
        if (confirm(this.local_page_keys.confirm_retouchers_delay_time)) {
          payload['max_retoucher_rejected_delay'] = '';
        }
      }
      if (this.retoucherRejectedBusyLimitTime !== null && this.retoucherRejectedBusyLimitTime !== '00:00' && this.retoucherRejectedBusyLimitTime !== '') {
        payload['max_retoucher_rejected_busy_delay'] = this.retoucherRejectedBusyLimitTime
      } else if (this.retoucherRejectedBusyLimitTime === '') {
        if (confirm(this.local_page_keys.confirm_retouchers_delay_time)) {
          payload['max_retoucher_rejected_busy_delay'] = '';
        }
      }
      if (this.pro_retoucherLimitTime !== null && this.pro_retoucherLimitTime !== '00:00' && this.pro_retoucherLimitTime !== '') {
        payload['max_pro_retoucher_delay'] = this.pro_retoucherLimitTime;
      } else if (this.pro_retoucherLimitTime === '') {
        if (confirm(this.local_page_keys.confirm_pro_retouchers_delay_time)) {
          payload['max_pro_retoucher_delay'] = '';
        }
      }

      if (this.retoucher_extra_minutes_for_queue_priority !== null ) {
        payload['retoucher_extra_minutes_for_queue_priority'] = this.retoucher_extra_minutes_for_queue_priority;
      }

      if (this.pro_retoucher_extra_minutes_for_queue_priority !== null ) {
        payload['pro_retoucher_extra_minutes_for_queue_priority'] = this.pro_retoucher_extra_minutes_for_queue_priority;
      }

      if (Object.keys(payload).length > 0) {
        await this.$store.dispatch('adminAppConfig/updateDelayOptions', payload);
        let data = await this.$store.getters['adminAppConfig/updateDelayOptions'];
        this.filterForDelaySettings(data);
      }
    },

    filterForDelaySettings(data) {
      if (Object.keys(data).includes('ignore_pro_retouchers')) {
        this.beforeUpdateProRetouchers = data.ignore_pro_retouchers.value;
        if(this.beforeUpdateProRetouchers !== null && this.beforeUpdateRetouchers != '') {
          this.selectedProRetouchers =JSON.parse(this.beforeUpdateProRetouchers);
          this.beforeUpdateProRetouchers = this.selectedProRetouchers.toString();
        }
        if(this.beforeUpdateProRetouchers === null) this.beforeUpdateProRetouchers = '';
      }
      if (Object.keys(data).includes('ignore_retouchers')) {
        this.beforeUpdateRetouchers = data.ignore_retouchers.value;
        if(this.beforeUpdateRetouchers !== null && this.beforeUpdateRetouchers != '') {
          this.selectedRetouchers = JSON.parse(this.beforeUpdateRetouchers);
          this.beforeUpdateRetouchers = this.selectedRetouchers.toString();
        }
        if (this.beforeUpdateRetouchers === null) this.beforeUpdateRetouchers = '';
      }
      if (Object.keys(data).includes('max_retoucher_delay')) {
        this.beforeUpdateRetoucherDelay = data.max_retoucher_delay.value;
        this.retoucherLimitTime = this.beforeUpdateRetoucherDelay;
      }
      if (Object.keys(data).includes('max_pro_retoucher_delay')) {
        this.beforeUpdateProRetoucherDelay = data.max_pro_retoucher_delay.value;
        this.pro_retoucherLimitTime = this.beforeUpdateProRetoucherDelay;
      }
      if (Object.keys(data).includes('max_retoucher_rejected_delay')) {
        this.beforeUpdateRetoucherRejectedDelay = data.max_retoucher_rejected_delay.value;
        this.retoucherRejectedLimitTime = this.beforeUpdateRetoucherRejectedDelay;
      }
      if (Object.keys(data).includes('max_retoucher_rejected_busy_delay')) {
        this.beforeUpdateRetoucherRejectedBusyDelay = data.max_retoucher_rejected_busy_delay.value;
        this.retoucherRejectedBusyLimitTime = this.beforeUpdateRetoucherRejectedBusyDelay;
      }

      if (Object.keys(data).includes('retoucher_extra_minutes_for_queue_priority')) {
        this.beforeUpdate_retoucher_extra_minutes_for_queue_priority = data.retoucher_extra_minutes_for_queue_priority.value;
        this.retoucher_extra_minutes_for_queue_priority = this.beforeUpdate_retoucher_extra_minutes_for_queue_priority;
      }
      if (Object.keys(data).includes('pro_retoucher_extra_minutes_for_queue_priority')) {
        this.beforeUpdate_pro_retoucher_extra_minutes_for_queue_priority = data.pro_retoucher_extra_minutes_for_queue_priority.value;
        this.pro_retoucher_extra_minutes_for_queue_priority = this.beforeUpdate_pro_retoucher_extra_minutes_for_queue_priority;
      }

    }
  },
  computed: {
    changesWasInserted() {
      return this.selectedRetouchersChanged
          || this.selectedProRetouchersChanged
          || this.delayRetouchersChanged
          || this.delayProRetouchersChanged
          || this.delayRetoucherRejectedChanged
          || this.delayRetoucherRejectedBusyChanged
          || this.delayExtraMinutesForQueuePriorityChanged;
    },
    selectedProRetouchersChanged() {
      return (this.selectedProRetouchers.length > 0 && this.selectedProRetouchers.toString() !== this.beforeUpdateProRetouchers);
    },
    selectedRetouchersChanged() {
      return (this.selectedRetouchers.length > 0 && this.selectedRetouchers.toString() !== this.beforeUpdateRetouchers);
    },
    delayRetouchersChanged() {
      return (this.retoucherLimitTime !== null && this.retoucherLimitTime !== '00:00' && this.retoucherLimitTime !== this.beforeUpdateRetoucherDelay);
    },
    delayProRetouchersChanged() {
      return (this.pro_retoucherLimitTime !== null && this.pro_retoucherLimitTime !== '00:00' && this.pro_retoucherLimitTime !== this.beforeUpdateProRetoucherDelay);
    },
    delayRetoucherRejectedChanged() {
      return (this.retoucherRejectedLimitTime !== null && this.retoucherRejectedLimitTime !== '00:00' && this.retoucherRejectedLimitTime !== this.beforeUpdateRetoucherRejectedDelay);
    },
    delayRetoucherRejectedBusyChanged() {
      return (this.retoucherRejectedBusyLimitTime !== null && this.retoucherRejectedBusyLimitTime !== '00:00' && this.retoucherRejectedBusyLimitTime !== this.beforeUpdateRetoucherRejectedBusyDelay);
    },
    delayExtraMinutesForQueuePriorityChanged() {
      return (this.retoucher_extra_minutes_for_queue_priority !== null && this.retoucher_extra_minutes_for_queue_priority !== this.beforeUpdate_retoucher_extra_minutes_for_queue_priority)
          || (this.pro_retoucher_extra_minutes_for_queue_priority !== null && this.pro_retoucher_extra_minutes_for_queue_priority !== this.beforeUpdate_pro_retoucher_extra_minutes_for_queue_priority);
    },
  },
  async created() {
    this.local_page_keys = await this.$filtergetLocalisationPage('app_config');
    await this.getRole();
    await this.getRetouchersList();
    await this.getProRetouchersList();
  }
}
</script>

<style scoped>

</style>